module.exports = __webpack_public_path__ + "static/media/plus-button.e61d7033.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/AboutPage/plus-button.svg
// module id = 836
// module chunks = 0